/**
 * @file banner 入口
 * @author izzieyspu
 */
import React, { useRef } from 'react';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Flex, Link } from '@tencent/odc';

// 导入必要的 Swiper 样式
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

interface BannerGuideItem {
  key: string;
  href: string;
  image: string;
}

export interface BannerGuideProps {
  data: BannerGuideItem[];
}

const BannerEntry: React.FC<BannerGuideProps> = (props) => {
  const { data } = props;
  const swiperRef = useRef<SwiperRef | null>(null);

  return (
    <Swiper
      loop
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      pagination={{
        clickable: true,
        type: 'bullets',
        renderBullet: (_: any, className: string) => `<span class="${className}"></span>`,
      }}
      modules={[Autoplay, Pagination]}
      className="w-guide-swiper w-full h-full"
      ref={swiperRef}
    >
      {data.map((item) => (
        <SwiperSlide key={item.key}>
          <Link href={item.href} target="_blank" data-report={`home-banner-entry.${item.key}`}>
            <Flex
              itemsCenter
              radius={12}
              clipContent
              className="relative"
              h={104}
            >
              <img src={item.image} width={426} height={104} alt="" className="relative left-0 z-1" />
            </Flex>
          </Link>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default BannerEntry;
